<template>
  <aw-drag 
    class="Square select-none" 
    :class="{ 
      'Square__Jiggle': jiggle,
      'Square__Folder': item.type === 'folder',
    }" 
    :drag-item="item" 
    :drag-start-timeout="300" 
    :original-drop-area-id="originalDropAreaId"
    :enable="dragEnabled"
  >
    <div class="Square__Pic cursor-pointer bg-white rounded-md z-1" @click.stop="open" :class="{ 'shadow-md': item.type === 'folder' }" :style="{ ...jiggleStyle, ...(bgColorStyle || {}) }">
      <card-slider v-if="previews?.length > 1 && !bgColorStyle" class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="preview in previews" :key="preview">
            <img class="rounded-md pointer-events-none" :src="preview" alt="" draggable="false"/>
          </div>
        </div>
      </card-slider>
      <template v-else-if="previews?.length === 1 && !bgColorStyle">
        <div class="swiper-wrapper z-1">
          <div 
            class="swiper-slide" 
            v-for="preview in previews" 
            :key="preview"
          >
            <img class="rounded-md pointer-events-none" :src="preview" alt="" draggable="false"/>
          </div>
        </div>
        <div
          v-if="item.icon_text"
          :style="textColorStyle"
          class="text-sm md:text-xl break-word text-center absolute inset-0 flex items-center justify-center flex-row max-w-full p-4 z-1"
        >
          <div 
            class="line-clamp-4"
            :style="textColorStyle"
          >
            {{ item.icon_text }}
          </div>
        </div>
      </template>
      <div 
        v-else-if="item.icon_text"
        class="Square__IconText z-1"
      >
        <div 
          class="line-clamp-4"
          :style="textColorStyle"
        >
          {{ item.icon_text }}
        </div>
      </div>
      <!--
      <div v-else-if="!isEditForm">
        <div 
          class="Square__Inicials rounded-md" 
          :class="{'!bg-transparent': bgColorStyle}" 
        >
          {{ inicials }}
        </div>
      </div>
      -->

      <div v-else>
        <div 
          class="Square__IconText rounded-md bg-bc-blue z-1"
          :style="bgColorStyle"
        >
          <div 
            class="line-clamp-4"
            :style="textColorStyle"
          >
            {{ item.name }}
          </div>
        </div>
      </div>

      <div
        v-if="!isEditForm"
        ref="Square__Dot"
        :data-item-index="rank"
        class="Square__Dot cursor-pointer ring-white ring-1 z-7"
        :class="{
          'Square__Dot--active': bcSelectedStore.selected.has(item.url)
        }"
        @click.stop="bcSelectedStore.select(
          item, 
          {
            isRecursive: true,
            isShift: $event.shiftKey,
            itemIndex: rank,
          }
        )"
      ></div>

      <!--  eye -->
      <div
        class="Square__Eye flex items-center justify-center z-7"
        :class="infoClass"
        v-if="(item.hidden || bookmarked || notPublished) && !isEditForm"
      >
        <aw-icon
          icon="eye-closed"
          class="w-4 h-4  cursor-pointer text-red-600 hover:text-bc-blue"
          :class="{ '!mr-2': bookmarked || notPublished }"
          v-if="item.hidden"
          v-tippy="$t('Hidden')"
        ></aw-icon>
        <aw-icon
          icon="pen"
          class="w-4 h-4  cursor-pointer text-red-600 hover:text-bc-blue"
          :class="{ '!mr-2': bookmarked || item.hidden }"
          v-if="notPublished"
          v-tippy="$t('Document is not pusblished')"
        ></aw-icon>
        <aw-icon
          icon="star"
          class="w-4 h-4  cursor-pointer text-yellow-600 hover:text-bc-blue"
          v-if="bookmarked"
          v-tippy="$t('Pinned')"
        ></aw-icon>
      </div>
    </div>
    <div 
      v-if="!isEditForm"
      class="Square__Text leading-tight py-1 text-sm text-gray-500"
    >
      <!-- dots dropdown  -->
      <aw-dropdown
        v-if="!$presenter.isPublic && !isEditForm"
        placement="bottom-end"
        :offset="[0, 8]"
        class="Square__Dots flex items-center justify-center cursor-pointer z-8"
      >
        <template v-slot:btn="{ toggle }">
          <div @click.stop="toggle" class="flex items-center justify-center">
            <aw-icon
              icon="dots"
              class="w-4 h-4  text-black hover:text-bc-blue"
            ></aw-icon>
          </div>
        </template>
        <template v-slot:dropdown="{ opened, dropdown, close }">
          <div
            v-show="opened"
            :ref="dropdown"
            class="Dropdown Dropdown--Hover absolute rounded-md bg-white  max-w-xs text-sm top-full right-0 shadow-md z-20"
          >
            <folder-dropdown :item="item" @onselect="close" />
          </div>
        </template>
      </aw-dropdown>
      <span class="opacity-0 line-clamp-2 pointer-events-none">
        <aw-icon
          v-if="item.type === 'folder'"
          :icon="item.link ? 'link' : 'folder'"
          class="w-4 h-4"
        /> {{ item.name }}
      </span>
      <a 
        class="Square__TextVisible" 
        :href="item.link ? item.link : item.url" 
        ref="link" 
        :target="item.link ? '_blank' : '_self'"
      >
        <aw-icon
          v-if="item.type === 'folder'"
          :icon="item.link ? 'link' : 'folder'"
          class="w-4 h-4"
        /> {{ item.name }}
      </a>
    </div>
  </aw-drag>
</template>

<script>
import FolderListItem from '../../mixins/FolderListItem'
import Selected from '../../mixins/Selected'

export default {
  mixins: [
    FolderListItem,
    Selected,
  ],
  props: {
    jiggle: {
      type: Boolean,
      default: false,
    },
    isEditForm: {
      type: Boolean,
      default: false,
    },
    originalDropAreaId: {
      type: String,
      default: null,
    },
  },
  computed: {
    inicials() {
      const name = this.item.name;
      const words = new String(name)
        .replace(/([!@#$%^&*(){}[\]<?>\\\-_`~;!§"+/ˇ'´=,.¨])/gi, "")
        .split(" ")
        .filter(function(value) {
          return value != "";
        });

      let short;
      if (words.length > 1) {
        short = words.map(function(w) {
          return w.substring(0, 1);
        });

        short = short[0] + short[1];
      } else if (words.length > 0) {
        short = words[0].substring(0, 2);
      } else {
        return name.substring(0, 2);
      }

      return short;
    },
    jiggleStyle() {
      if (!this.jiggle) {
        return
      }

      return {
        animationDelay: (Math.random() * (0.75 - 0.05) + 0.05) + 's',
        animationDuration: (Math.random() * (0.4 - 0.25) + 0.25) + 's',
      }
    },
    bgColorStyle() {
      if (!this.item.icon_bg_color) {
        return null
      }

      return {
        backgroundColor: this.item.icon_bg_color
      }
    },
    textColorStyle() {
      if (!this.item.icon_text_color) {
        return null
      }

      return {
        color: this.item.icon_text_color
      }
    }
  },
  mounted() {
    this.assignItemToSelectBtn('Square__Dot', this.item)
  }
};
</script>

<style lang="scss" scoped></style>
